import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

type SendCodePassword = {
  sendCode: (admin: { email: string }) => Promise<any>;
  loading: boolean;
};

export default function useSendCodeForgotPassword(): SendCodePassword {
  const [loading, setLoading] = useState(false);

  async function sendCode(admin: { email: string }): Promise<any> {
    setLoading(true);
    try {
      const { status, data } = await api.post(
        `v1/backoffice/admins/send-token`,
        {
          email: admin.email,
        },
      );

      if (status === 201) {
        toast.success(ToastMessages.account.success.accountForgotPassword);
        return { status, data };
      }
    } catch (error) {
      toast.success(ToastMessages.account.error.accountForgotPassword);
    } finally {
      setLoading(false);
    }
  }

  return { sendCode, loading };
}
